export default __webpack_public_path__ + "static/media/open-book.e74a7e8b.svg";